import { defineComponent as _defineComponent } from 'vue'
import formatTime from "@/utils/format-time";
import { computed } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'VideoTimeline',
  props: {
    duration: { default: 90 }
  },
  setup(__props: any) {

const props = __props as { duration: number }



const delimeter = computed(() => {
  const { duration } = props;

  if (duration < 5) {
    return 1;
  }

  if (duration < 10) {
    return 2;
  }

  if (duration < 20) {
    return 5;
  }

  if (duration < 60) {
    return 10;
  }

  if (duration < 5 * 60) {
    return 30;
  }

  return 60;
});

const showRemaindingTime = computed(() => {
  const remaindingTime = props.duration % delimeter.value;

  return remaindingTime / props.duration > 0.05;
});

const incrementWidth = computed(() => {
  return (delimeter.value / 5 / props.duration) * 100;
});

const delimeterWidth = computed(() => {
  return (delimeter.value / props.duration) * 100 + "%";
});

const delimeters = computed(() => {
  let count = Math.floor(props.duration / delimeter.value);

  return [...Array(count).keys()].map((_, i) => i * delimeter.value);
});

return { __sfc: true,props, delimeter, showRemaindingTime, incrementWidth, delimeterWidth, delimeters, formatTime }
}

})